var Handlebars = require("D:\\AVA\\code\\jwplayer\\JWP\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"infohelper-panel-wrapper\" id=\""
    + container.escapeExpression(((helper = (helper = helpers.wid || (depth0 != null ? depth0.wid : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"wid","hash":{},"data":data}) : helper)))
    + "\" style=\"display:none\">\r\n  <div class=\"bg\"></div>\r\n <a class=\"x-btn\" href=\"javascript:void(0);\">X</a>\r\n	<div class=\"infohelper-panel\">\r\n		"
    + ((stack1 = ((helper = (helper = helpers.htmlContent || (depth0 != null ? depth0.htmlContent : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"htmlContent","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\r\n		</p>\r\n	</div>\r\n</div>\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/webpack/templates/infohelper-template.handlebars
// module id = 92
// module chunks = 3